import type { SVGProps } from 'react';

const SvgScheduledReports = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="scheduled-reports">
      <path d="M6.52 7.45h.84V6h-.84a2.6 2.6 0 0 0-2.6 2.6v20.08a2.75 2.75 0 0 0 2.75 2.75h18.8a2.75 2.75 0 0 0 2.75-2.75V8.55A2.6 2.6 0 0 0 25.61 6H24.4v1.5h1.21a1.11 1.11 0 0 1 1.11 1.1v20.08a1.25 1.25 0 0 1-1.25 1.25H6.67a1.25 1.25 0 0 1-1.25-1.25V8.55a1.1 1.1 0 0 1 1.1-1.1" />
      <path d="M21.28 4h-1.62l-.1-.52a3.75 3.75 0 0 0-7.32 0l-.1.52h-1.58a1.85 1.85 0 0 0-1.88 1.84v2.27a.76.76 0 0 0 .75.75h13a.76.76 0 0 0 .75-.75V5.84A1.86 1.86 0 0 0 21.28 4m.38 3.35H10.18V5.84a.36.36 0 0 1 .38-.33h2.2a.73.73 0 0 0 .73-.61l.22-1.12a2.26 2.26 0 0 1 4.38 0l.22 1.12a.73.73 0 0 0 .73.61h2.24a.36.36 0 0 1 .38.33ZM12.94 17.46l-1.06 1.06 3 3a.8.8 0 0 0 .54.22.74.74 0 0 0 .52-.22l8.62-8.58-1.06-1.07-8.08 8.06Z" />
      <path d="M15.46 26.73A7.49 7.49 0 0 0 23 19.25a7.7 7.7 0 0 0-.19-1.67l-1.46.33a6 6 0 1 1-2.48-3.62l.84-1.24a7.49 7.49 0 1 0-4.2 13.68Z" />
    </g>
  </svg>
);

export default SvgScheduledReports;
